<template>
    <v-navigation-drawer app>
        <v-list dense>
            <v-list-item>
                <v-list-item-title class="sidebar-title"> Sidebar Menu Component </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {},
    methods: {},
};
</script>
